<template>
  <div class="privacy-subsection">
    <h3 v-if="title">{{ title }}</h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PrivacySubsection',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.privacy-subsection {
  margin-top: 1.5rem;
}

.privacy-subsection h3 {
  color: #667eea;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-size: 1.4rem;
  font-weight: 600;
}

@media (max-width: 768px) {
  .privacy-subsection h3 {
    font-size: 1.2rem;
  }
}
</style>

